import { Box } from '@mui/material';
import { LanguageSkillEntry } from 'utils/cv-form-db';
import { EditModeNavigationButtons } from '../../components/EditModeNavigationButtons';
import { PreviousStepNavigationButton } from '../../components/PreviousStepNavigationButton';
import { StepNavigationButton } from '../../components/StepNavigationButton';
import { RootBox } from '../../components/styledComponents';
import { useCVStepActions } from '../../hooks/useCVStepActions';
import { useEditModeNavigation } from '../../hooks/useEditModeNavigation';
import DeleteLanguageSkillModal from './DeleteLanguageSkillModal';
import { LanguageSkillsContent } from './LanguageSkillsContent';

export const LanguageSkillsStep = () => {
  const { isEditMode } = useEditModeNavigation();

  const {
    isFormOpen,
    isEditing,
    editingItem,
    deleteModalState,
    handleAdd,
    handleEdit,
    handleDeleteClick,
    handleConfirmDelete,
    handleCancelDelete,
    handleEditClick,
    handleAddClick,
    handleCancelForm
  } = useCVStepActions<LanguageSkillEntry>({
    fieldName: 'languageSkills',
    disableAutoSave: isEditMode
  });

  if (isEditMode) {
    return (
      <RootBox
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <LanguageSkillsContent
          isFormOpen={isFormOpen}
          isEditing={isEditing}
          editingItem={editingItem || null}
          onAdd={handleAdd}
          onEdit={handleEdit}
          onCancel={handleCancelForm}
          onAddClick={handleAddClick}
          onEditClick={handleEditClick}
          onDeleteClick={handleDeleteClick}
        />

        <Box sx={{ flex: 1 }} />
        {!isFormOpen && <EditModeNavigationButtons />}

        <DeleteLanguageSkillModal
          isOpen={deleteModalState.isOpen}
          onClose={handleCancelDelete}
          onConfirm={handleConfirmDelete}
        />
      </RootBox>
    );
  }

  return (
    <RootBox
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <LanguageSkillsContent
        isFormOpen={isFormOpen}
        isEditing={isEditing}
        editingItem={editingItem || null}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onCancel={handleCancelForm}
        onAddClick={handleAddClick}
        onEditClick={handleEditClick}
        onDeleteClick={handleDeleteClick}
      />

      <Box sx={{ flex: 1 }} />

      {!isFormOpen && (
        <>
          <StepNavigationButton step="LANGUAGE_SKILLS" />
          <PreviousStepNavigationButton step="LANGUAGE_SKILLS" />
        </>
      )}

      <DeleteLanguageSkillModal
        isOpen={deleteModalState.isOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
      />
    </RootBox>
  );
};
